import { createFileRoute } from "@tanstack/react-router";
import IndustriesOverview from "@/pages/IndustriesOverview";
import { hubHead } from "@/lib/route-seo";

export const Route = createFileRoute("/industries/")({
  head: () => hubHead("/industries"),
  component: IndustriesOverview,
});
